define([
    "jquery",
    "underscore",
    "marionette",
], function ($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'monthName': '.month_name',
            'lessonYear': '.lesson',
            'tableRows': '#webinar_table_rows',
            'year': '.webinar_year',
            'tabMonths': '#tab_months',
            'title': '#webinar_title'
        },

        events: {
            'click @ui.monthName': 'requestWebinars',
            'click @ui.year': 'requestWebinars'
        },

        initialize: function () {
            this.bindUIElements();
        },

        requestWebinars: function (e) {
            const that = this;

            // no need to fetch again for rendered data.
            if ($(e.target.parentElement).attr('class') === 'active') return;

            const hasYearClicked = $(e.target).hasClass('webinar_year');
            const today = new Date();
            const lang = window.lang;
            let year, month;

            // if user clicks a year.
            if (hasYearClicked) {
                year = $(e.target).data('year');
                month = (today.getFullYear() === year) ? today.getMonth() : 1;
                month = year < 2021 ? 7 : 1;
            }
            // if user clicks a month.
            else {
                year = $('li.lesson.active > a').data('year');
                month = $(e.target).data('month');
            }

            const params = {lang, year, month};

            $.get(
                '/rest_forex_webinar/webinars',
                params,
                function (webinars, status) {
                    ;
                    that.renderWebinars(webinars, hasYearClicked, params);
                }
            )
        },

        renderWebinars: function (webinars, hasYearClicked, params) {
            const that = this;

            that.ui.tableRows.empty();

            if (hasYearClicked) {
                that.ui.title.text(`${params.year} WEBINAR Sessions`);
                that.renderTabMonths(that, params);
            }

            that.renderWebinarRows(that, webinars);
            that.bindUIElements();
        },

        renderTabMonths: function (that, params) {
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

            that.ui.tabMonths.empty();

            const activeMonth = params.month;
            for (let month = 1; month < 13; month++) {
                const html = `
                        <li style="cursor: pointer;" class="${(month === activeMonth) ? 'active' : ''}">
                            <a class="month_name" data-toggle="tab" data-month="${month}">
                                ${monthNames[month - 1]}
                            </a>
                        </li>
                    `;

                that.ui.tabMonths.append(html);
            }
        },

        renderWebinarRows: function (that, webinars) {
            webinars.forEach((webinar) => {
                const webinarDate = new Date(webinar.webinar_datetime);
                const tomorrowDate = new Date().setDate(new Date().getDate() + 1);

                let tableRow = `<tr>
                    <td>
                        <dl>
                            <dt>${webinar.day}</dt>
                            <dd>${webinar.month}</dd>
                        </dl>
                        <span>${webinar.time}  PM (GMT +8)<Br>${webinar.day_name}</span>
                    </td>
                    <td>
                        <img src="${webinar.flag_url}" alt="" class="flag">
                    </td>
                    <td>
                        <strong>${webinar.subject}</strong>
                        ${webinar.contents ? webinar.contents : ''}
                    </td>
                    <td>
                        <a href="${webinar.meeting_room_url}"
                           class="btn-apply${webinarDate > tomorrowDate ? '' : ' disabled'}"
                           target="_blank" >
                           ${webinarDate > tomorrowDate ? 'PARTICIPATE' : ' DONE'}
                        </a>
                    </td>
               </tr>`;

                that.ui.tableRows.append(tableRow);
            });
        }
    });
});
